const getClickEventClientXY = event => ({
  // pageX and Y are the absolute coordinates that take into account the page scroll position
  clientX: event.pageX,
  clientY: event.pageY,
});

export default getClickEventClientXY;
